// Shared fetch wrapper for the MS Office School backend (Cloudflare Worker).
// Configure REACT_APP_API_BASE in .env — see .env.example.

export const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

const NETWORK_ERROR = 'সার্ভারের সাথে যোগাযোগ করা যাচ্ছে না। ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।';
const GENERIC_ERROR = 'দুঃখিত, কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।';

export class ApiError extends Error {
  constructor(message, { status = 0, fieldErrors = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.fieldErrors = fieldErrors;
  }
}

// Error bodies look like { ok: false, message, errors? }; public messages are Bangla and safe to show.
export async function request(url, options = {}) {
  let res;
  try {
    res = await fetch(url, {
      ...options,
      headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}), ...options.headers },
    });
  } catch {
    throw new ApiError(NETWORK_ERROR);
  }

  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new ApiError(body?.message || GENERIC_ERROR, { status: res.status, fieldErrors: body?.errors || null });
  }
  return body;
}
